import type { Article, Category, Content, Resource } from '@dr-pam/common-types/database/client';

export type { ResourceType, Category } from '@dr-pam/common-types/database/client';

export type ArticleResource = Pick<Article, 'id' | 'slug' | 'title' | 'resourceTypeId' | 'modified'> & {
	_type: 'Article';
	sortOrder: number;
	categoryIds: string[];
};

export type ArticleWithContentResource = ArticleResource & {
	content?: Pick<Content, 'markdown' | 'publishedHtml' | 'publishedFrontmatter' | 'created' | 'modified'>;
};

export type ResourceResource = Pick<
	Resource,
	'id' | 'slug' | 'title' | 'filename' | 'url' | 'resourceTypeId' | 'modified'
> & {
	_type: 'Resource';
	sortOrder: number;
	categoryIds: string[];
};

export type ResourceHubResource = ArticleResource | ResourceResource;

export type ResourceHubFilterOptions = {
	categoryId?: string;
	resourceTypeId?: string;
	query?: string;
};

export type CategoryWithSubCategories = Category & { subCategories: CategoryWithSubCategories[] };

export function AricleToDto(article: Article, sortOrder: number, categoryIds: string[] = []): ArticleResource {
	return {
		_type: 'Article',
		id: article.id,
		modified: article.modified,
		slug: article.slug,
		title: article.title,
		resourceTypeId: article.resourceTypeId,
		sortOrder,
		categoryIds: Array.from(new Set(categoryIds)), // Remove duplicates
	};
}

export function ResourceToDto(resource: Resource, sortOrder: number, categoryIds: string[] = []): ResourceResource {
	return {
		_type: 'Resource',
		id: resource.id,
		modified: resource.modified,
		slug: resource.slug,
		title: resource.title,
		filename: resource.filename,
		url: resource.url,
		resourceTypeId: resource.resourceTypeId,
		sortOrder,
		categoryIds: Array.from(new Set(categoryIds)), // Remove duplicates
	};
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isArticle(resource: any): resource is ArticleResource {
	return resource['_type'] === 'Article';
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isResource(resource: any): resource is ResourceResource {
	return resource['_type'] === 'Resource';
}
